import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { validateGuid } from '../services/apiService';
import Container from '../components/Container';
import Content from '../components/Content';
import { Tab, Tabs } from 'react-bootstrap';
import { Row, Col, Card } from 'react-bootstrap';
import { getHeadersAPI } from '../api/ServicesConfiguration';

interface docsRecord {
  DocumentCode: string;
  Description_NL: string;
  GUID: string;
  isUploaded: boolean;
  isRequestedDocument?: boolean;
  isMandatoryDocument?: boolean;
}

function UploadPortal() {
  const navigate = useNavigate();

  //Get URL Parameters
  const queryParameters = new URLSearchParams(window.location.search);
  const guid = queryParameters.get('guid');
  const owner = queryParameters.get('owner');

  //variables
  const [mainDocs, setMainDocs] = useState<docsRecord[]>([]);
  const [partnerDocs, setPartnerDocs] = useState<docsRecord[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [businessType, setBusinessType] = useState<any>(0);

  // FetchData
  const fetchData = async () => {
    if (!(await validateGuid(guid!))) {
      //navigate('/ErrorPage');
    }
    try {
      const responseBusinessType = await axios.get(
        process.env.REACT_APP_BASE_API_URL + '/getBusinessTypeByGuid/' + guid,
        {
          headers: await getHeadersAPI()
        }
      );

      setBusinessType(responseBusinessType.data.businessType);

      const response = await axios.get(
        process.env.REACT_APP_BASE_API_URL + '/getDocuments/' + guid,
        {
          headers: await getHeadersAPI()
        }
      );

      if (response.data.filter((doc: any) => !doc.isUploaded).length > 0) {
        setMainDocs(response.data.filter((person: any) => person.Owner == 1));
        setPartnerDocs(
          response.data.filter((person: any) => person.Owner == 2)
        );
        setIsLoading(false);
      } else {
        axios
          .post(
            process.env.REACT_APP_BASE_API_URL + '/allDocSubmited',
            { guid: guid },
            {
              headers: await getHeadersAPI()
            }
          )
          .then((response) => {
            navigate('/ThankYouPage');
            // You can handle the response here
          })
          .catch((error) => {
            console.error('API Error:', error);
            setIsLoading(false);
          });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  //Run 1 time
  useEffect(() => {
    if (!guid) {
      // navigate("/ErrorPage");
    } else {
      setIsLoading(true);
      fetchData();
    }

  }, []);

  function docOnClick(guid: string, documentCode: string, owner: string) {
    navigate(
      '/Upload?guid=' +
        guid +
        '&documentCode=' +
        documentCode.trim() +
        '&owner=' +
        owner
    );
  }

  const overLayer = (
    <div className="over-layer">
      <div>Loading...</div>
    </div>
  );

  return (
    <div>
      <Content className="mt-5">
        <Container>
          <Card className="p-5">
            <Tabs
              className="nav-pills mb-5"
              defaultActiveKey={
                owner
                  ? owner == '1'
                    ? 'main'
                    : owner == '2'
                    ? 'partner'
                    : 'welcome'
                  : 'welcome'
              }
              justify
            >
              <Tab eventKey={'welcome'} title={'Welkom!'}>
                <WelcomeCard />
              </Tab>
              <Tab
                eventKey={'main'}
                title={businessType === 1 ? 'Tekenbevoegde 1' : 'Aanvrager'}
              >
                <div className="mb-5" style={{ textAlign: 'center' }}>
                  <h3>
                    <b>Upload documenten</b>
                  </h3>
                </div>
                <Row>
                  {mainDocs.map((f: docsRecord, i) => (
                    <UploadButton
                      key={f.GUID + f.DocumentCode + i + '1'}
                      documentCode={f.DocumentCode}
                      label={f.Description_NL}
                      isUploaded={f.isUploaded}
                      onClick={() => docOnClick(f.GUID, f.DocumentCode, '1')}
                    />
                  ))}
                </Row>
              </Tab>
              {partnerDocs.length > 0 ? (
                <Tab
                  eventKey={'partner'}
                  title={businessType === 1 ? 'Tekenbevoegde 2' : 'Partner'}
                >
                  <div className="mb-5" style={{ textAlign: 'center' }}>
                    <h3>
                      <b>Upload documenten</b>
                    </h3>
                  </div>
                  <Row>
                    {partnerDocs.map((f: docsRecord, i) => (
                      <UploadButton
                        key={f.GUID + f.DocumentCode + i + '2'}
                        documentCode={f.DocumentCode}
                        label={f.Description_NL}
                        isUploaded={f.isUploaded}
                        onClick={() => docOnClick(f.GUID, f.DocumentCode, '2')}
                      />
                    ))}
                  </Row>
                </Tab>
              ) : null}
            </Tabs>
            <Row>
              <Col>
                <img
                  src="../../dist/img/Refer_illustration.png"
                  className="float-right"
                  style={{ width: 285 }}
                />
              </Col>
            </Row>
          </Card>
        </Container>
      </Content>
      {isLoading ? overLayer : ''}
    </div>
  );
}

function WelcomeCard(language: any) {
  function Welcome() {
    return (
      <>
        <div className="mb-2" style={{ fontSize: 16, fontWeight: 700 }}>
          U kunt nu uw documenten uploaden door op de tab aanvragen of partner
          te klikken.
        </div>
        <div className="mb-2">
          <div>1. Upload de gevraagde documenten.</div>
          <div>2. Uw aanvraag wordt dan verder behandeld.</div>
          <div>3. Hierna krijgt u berichtgeving van ons over de uitslag.</div>
        </div>
        <div>
          <div className="mb-2" style={{ fontSize: 16, fontWeight: 700 }}>
            Snelle afhandeling van uw aanvraag?
          </div>
          Lees zorgvuldig de instructies per document voordat u gaat uploaden.
          Nog even dit:
          <div className="mb-2">
            <i className="fas fa-check text-success mr-2" />
            Upload een scan of foto van het originele document.
          </div>
          <div className="mb-2">
            <i className="fas fa-times text-danger mr-2" />
            Upload een pdf-of jpeg-bestand van de overig gevraagde documenten.
          </div>
          <div className="mb-2">
            <i className="fas fa-times text-danger mr-2" />
            Upload geen foto's van de overige documenten. Dit wordt alleen
            geaccepteerd voor het legitimatiebewijs.
          </div>
        </div>
      </>
    );
  }

  switch (language.lang) {
    default:
      return <Welcome />;
  }
}

function UploadButton(props: {
  documentCode: string;
  label: string;
  isUploaded?: boolean;
  isDisable?: boolean;
  onClick?: () => void;
}) {
  return (
    <div className="col-md-6 col-sm-6 col-12">
      {props.isUploaded ? (
        <div
          className="info-box shadow"
          style={{
            borderRadius: 50,
            backgroundColor: 'rgb(191 255 197 / 52%)'
          }}
        >
          <span className="info-box-icon text-danger">
            <ButtonIcon documentCode={props.documentCode} />
          </span>
          <div className="info-box-content">
            <span className="info-box-text">{props.label}</span>
          </div>
          <span
            className="info-box-icon text-success"
            style={{ borderRadius: 50 }}
          >
            <i className="fas fa-check " />
          </span>
        </div>
      ) : (
        <div
          className="info-box upload-button shadow"
          onClick={props.onClick}
          style={{ borderRadius: 50 }}
        >
          <span className="info-box-icon text-danger">
            <ButtonIcon documentCode={props.documentCode} />
          </span>
          <div className="info-box-content">
            <span className="info-box-text">{props.label}</span>
          </div>
        </div>
      )}
    </div>
  );
}

function ButtonIcon(props: { documentCode: string }) {
  // switch (props.documentCode) {
  //   case "nl":
  //     return <img src="../../dist/img/Image340.png"/>;
  //   case "fr":
  //     return <img src="../../dist/img/Refer_illustration.png"/>;
  //   default:
  //     return  <i className={"far fa-file"} />;
  // }

  return (
    <img src={'../../dist/img/Image' + props.documentCode.trim() + 'NL.png'} />
  );
}

export default UploadPortal;
